module.exports = __webpack_public_path__ + "img/3.8.TSS.94c2fd74.png";